import { defineStore } from 'pinia'
import type { Messenger } from '~/types'

export const useMessengerStore = defineStore('messenger', {
    state: () => ({
        messenger: null as Messenger | null,
        loaded: false,
        settings: {
            currentPage: 'home',

            currentTab: 'Content',
            tabs: [
                'Content',
                'Appearance',
            ],

            currentSubTab: "visitors",
            subTabs: [
                "visitors",
                "users",
            ]
        },
    }),

    actions: {
        async fetchMessenger(force = false) {
            if (this.loaded && !force) return
            const { $api } = useNuxtApp();
            await $api.get("/messenger")
                .then((response) => {
                    this.messenger = response.data;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.loaded = true;
                })
        },
    }
})